export default {
  computed: {
    panelColor() {
      return this.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3';
    },
  },
};
